// extracted by mini-css-extract-plugin
module.exports = {"Grid":"styles_Grid__1MPy9","Grid-title":"styles_Grid-title__GBcia","Grid-content":"styles_Grid-content__30f6R"};